import { ApplicationTypes } from 'metalworks-domain'
import { useCallback, useState } from 'react'

import { MetalworksAnalytics, analyticsService } from '../../../systems/analytics'
import { configuratorInterface } from '../../../systems/configurator-interface'
import type { FinalizationFormData } from '../shared/JobDetailsForm'
import { BulkPlateJobDetailsDialog } from './BulkPlateJobDetailsDialog'
import { BulkPlateTableDialog } from './BulkPlateTableDialog'

enum WizardStep {
  JobDetails = 1,
  TableConfiguration = 2,
}

interface BulkFinalizationWizardProps {
  onSuccess: (returnUrl: string | null) => void
}

export const BulkFinalizationWizard = (props: BulkFinalizationWizardProps) => {
  const { onSuccess } = props

  const { navigationSystem, storeSystem } = configuratorInterface.useDomain()

  const [currentStep, setCurrentStep] = useState<WizardStep>(WizardStep.JobDetails)
  const [jobDetailsData, setJobDetailsData] = useState<FinalizationFormData | null>(null)

  // Handle navigation back to summary
  const handleBackToSummary = useCallback(() => {
    analyticsService.push(MetalworksAnalytics.BackToSummaryButtonClicked())
    storeSystem.stageAndCommit([navigationSystem.getNavigationUpdate(ApplicationTypes.NavigationState.Summary)])
    setCurrentStep(WizardStep.JobDetails)
    setJobDetailsData(null)
  }, [navigationSystem, storeSystem])

  // Handle moving from step 1 to step 2
  const handleJobDetailsSubmit = useCallback((data: FinalizationFormData) => {
    setJobDetailsData(data)
    setCurrentStep(WizardStep.TableConfiguration)
  }, [])

  // Step 2: Table Configuration
  if (currentStep === WizardStep.TableConfiguration && jobDetailsData) {
    return <BulkPlateTableDialog jobDetailsData={jobDetailsData} onCancel={handleBackToSummary} onSuccess={onSuccess} />
  }

  // Step 1: Job Details
  return <BulkPlateJobDetailsDialog onBack={handleBackToSummary} onNext={handleJobDetailsSubmit} />
}
